import { render, staticRenderFns } from "./pages.vue?vue&type=template&id=25c1677a&scoped=true"
import script from "./pages.vue?vue&type=script&lang=js"
export * from "./pages.vue?vue&type=script&lang=js"
import style0 from "./pages.vue?vue&type=style&index=0&id=25c1677a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c1677a",
  null
  
)

export default component.exports